<template lang="">
    <div ref="container">
        <div class="title">参与的课程</div>
        <div class="box">
            <van-tabs
                type="card"
                v-model="where.type"
                color="#C8B072"
                title-active-color="#fff"
                title-inactive-color="#C8B072"
            >
                <van-tab title="已报名课程"></van-tab>
                <van-tab title="已结束课程"></van-tab>
            </van-tabs>

            <div class="items">
                <router-link
                    :to="'/classes/' + item.id"
                    class="item"
                    v-for="(item, i) in lists"
                    :key="i"
                >
                    <div class="image">
                        <van-image :src="item.thumb" />
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <div class="time">
                        报名时间：{{ item.start_time_text }}-{{ item.end_time_text }}
                    </div>
                    <div class="tips" :class="'status-' + item.apply_status"></div>
                </router-link>
            </div>

            <van-loading v-if="!loaded">
                加载中
            </van-loading>
            <van-empty
                description="暂无课程"
                :image="require('@images/nodata.png')"
                v-if="lists.length === 0 && where.page > 1"
            />
        </div>
    </div>
</template>
<script>
import { getUserClasses } from '@api/user';
export default {
    name: 'UserClasses',
    data() {
        return {
            lists: [],
            where: {
                type: 0,
                page: 1,
                limit: 20
            },
            loaded: false,
            loading: false
        };
    },
    watch: {
        $route(n) {
            if (n.name === 'UserClasses') {
                this.loaded = false;
                this.loading = false;
                this.where.page = 1;
                this.$set(this, 'lists', []);
                this.getLists();
            }
        },
        'where.type': function() {
            this.loaded = false;
            this.loading = false;
            this.where.page = 1;
            this.$set(this, 'lists', []);
            this.getLists();
        }
    },
    mounted() {
        this.getLists();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.getLists();
        });
    },
    methods: {
        getLists() {
            let that = this;
            if (that.loaded == true || that.loading == true) return;
            that.loading = true;
            getUserClasses(this.where)
                .then(res => {
                    that.loading = false;
                    that.lists.push.apply(that.lists, res.data);
                    that.loaded = res.data.length < that.where.limit;
                    that.where.page = that.where.page + 1;
                })
                .catch(err => {
                    return that.$dialog.error(err);
                });
        }
    }
};
</script>
